var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MglMarker',{attrs:{"coordinates":_vm.markerCoordinates,"offset":[0, -20]}},[_c('i',{class:{ 'modified-z-index': _vm.foreground },attrs:{"slot":"marker"},slot:"marker"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }